import React, { useEffect, useState } from 'react';
import Confetti from 'react-confetti';
import { usePanelNavigation } from './vmSlidingPanel';
import { VMHome } from './vmHome';

export const VMWelcomePanel = ({ email, user_uuid, changeSection, isNewUser = false }) => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });
  const [showConfetti, setShowConfetti] = useState(true);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Handle transition timing
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowConfetti(false);
    }, 5000);

    const navigationTimer = setTimeout(() => {
      if (changeSection) {
        changeSection('home', user_uuid);
      }
    }, 6000);

    return () => {
      clearTimeout(timer);
      clearTimeout(navigationTimer);
    };
  }, [changeSection, user_uuid]);

  return (
    <div className="vm-section">
      {showConfetti && (
        <Confetti
          width={windowSize.width}
          height={windowSize.height}
          numberOfPieces={800}
          tweenDuration={3000}
          recycle={true}
          run={showConfetti}
          colors={['#2ecc71', '#3498db', '#e74c3c', '#f1c40f', '#9b59b6']} // Vote Machine-ish colors
          gravity={0.2} // Slower fall
        />
      )}
      <div className="vm-section-title">
        <h2>{isNewUser ? 'Welcome!' : 'Welcome Back!'}</h2>
      </div>

      <div className="vm-quoted-text">
        "The ballot is stronger than the bullet."
        - Abraham Lincoln
      </div>
      <div>
        <p>{isNewUser ? 'Welcome to' : 'Welcome back to'} Vote Machine, {email}!</p>
        <p>Taking you to your assemblies...</p>
      </div>
    </div>
  );
};